// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__rv-WH","selected":"Chip_selected__3cXlZ"};